import { Cookies } from "react-cookie";
import cookiesKeys from "Common/cookies/cookiesKeys";
const setCookieClientAuth = (token) => {
    const cookies = new Cookies();
    cookies.set(cookiesKeys.clientAuth, encodeURIComponent(JSON.stringify(token)), {
        path: "/",
        sameSite: "strict",
        secure: true
    });
};
export default setCookieClientAuth;
